mutation updateUserPayload($payloadOption: String!, $payloadValue: String!) {
    updateUserPayload(payloadOption: $payloadOption, payloadValue: $payloadValue)
}
